// Pre-built page templates for quick start
// Use getTemplates(t) to get localized versions
export const TEMPLATES = [
  {
    id: 'blank',
    name: 'Leer',
    descriptionKey: 'pagebuilder.blankPageDescription',
    thumbnail: '📄',
    tree: {
      id: 'root',
      type: 'root',
      children: []
    }
  },
  {
    id: 'preset-register',
    name: 'Preset: Register (Standard)',
    descriptionKey: 'pagebuilder.standardFormDescription',
    thumbnail: '📝',
    tree: {
      id: 'root',
      type: 'root',
      version: 1,
      children: [
        {
          id: 'n_preset_section_register',
          type: 'section',
          props: { padding: 'lg', background: 'surface' },
          children: [
            {
              id: 'n_preset_container_register',
              type: 'container',
              props: {},
              children: [
                {
                  id: 'n_preset_brand',
                  type: 'companyBrand',
                  props: { showAddress: true }
                },
                {
                  id: 'n_preset_spacer1',
                  type: 'spacer',
                  props: { heightPx: 8 }
                },
                {
                  id: 'n_preset_heading',
                  type: 'heading',
                  props: { text: 'Aktion – Scan', level: 2 }
                },
                {
                  id: 'n_preset_spacer2',
                  type: 'spacer',
                  props: { heightPx: 8 }
                },
                {
                  id: 'n_preset_text',
                  type: 'text',
                  props: { html: '<p>Bitte E-Mail und Name angeben, um einen persönlichen Code zu erhalten.</p>' }
                },
                {
                  id: 'n_preset_spacer3',
                  type: 'spacer',
                  props: { heightPx: 12 }
                },
                {
                  id: 'n_preset_email',
                  type: 'codeRequestEmail',
                  props: { label: 'E-Mail' }
                },
                {
                  id: 'n_preset_spacer4',
                  type: 'spacer',
                  props: { heightPx: 6 }
                },
                {
                  id: 'n_preset_name',
                  type: 'codeRequestName',
                  props: { label: 'Name', required: true }
                },
                {
                  id: 'n_preset_spacer5',
                  type: 'spacer',
                  props: { heightPx: 6 }
                },
                {
                  id: 'n_preset_consent',
                  type: 'codeRequestConsent',
                  props: { label: 'Newsletter Einwilligung', required: true }
                },
                {
                  id: 'n_preset_spacer6',
                  type: 'spacer',
                  props: { heightPx: 10 }
                },
                {
                  id: 'n_preset_submit',
                  type: 'codeRequestSubmit',
                  props: { submitLabel: 'E-Mail bestätigen', submitLabelLoading: 'Aktiviere...' }
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    id: 'preset-code',
    name: 'Preset: Code (Standard)',
    descriptionKey: 'pagebuilder.standardDisplayDescription',
    thumbnail: '🎫',
    tree: {
      id: 'root',
      type: 'root',
      version: 1,
      children: [
        {
          id: 'n_preset_section_code',
          type: 'section',
          props: { padding: 'lg', background: 'surface' },
          children: [
            {
              id: 'n_preset_container_code',
              type: 'container',
              props: {},
              children: [
                {
                  id: 'n_preset_heading_code',
                  type: 'heading',
                  props: { text: 'Dein persönlicher Code', level: 2 }
                },
                {
                  id: 'n_preset_display',
                  type: 'codeDisplay',
                  props: { hint: 'Diesen Code kannst du mehrfach ansehen. Er wird bei der Einlösung durch Mitarbeiter deaktiviert.' }
                }
              ]
            }
          ]
        }
      ]
    }
  }
];

// Helper function to generate unique IDs for template nodes
export function cloneTemplateWithNewIds(tree) {
  const genId = () => 'n_' + Math.random().toString(36).substring(2, 11);
  
  function cloneNode(node) {
    const cloned = {
      ...node,
      id: node.id === 'root' ? 'root' : genId(),
      props: { ...node.props }
    };
    
    if (node.children && Array.isArray(node.children)) {
      cloned.children = node.children.map(cloneNode);
    }
    
    return cloned;
  }
  
  return cloneNode(tree);
}

// Helper to get templates with localized descriptions
export function getLocalizedTemplates(t) {
  return TEMPLATES.map(tpl => ({
    ...tpl,
    description: tpl.descriptionKey ? t(`common.${tpl.descriptionKey}`) : tpl.description
  }));
}
